/* ── [A16-06] Czyszczenie danych kadrowych z localStorage przy wylogowaniu ──

   BYŁO: panel offboardingu (ETeczkaOffboardingPanel) i szkic świadectwa pracy
   (SwiadectwoPracyPreview) trzymają swój stan WYŁĄCZNIE w localStorage — backend
   nie ma dla nich żadnego endpointu. Wylogowanie czyściło tylko klucze "user"
   i "permissions" (AuthContext.logout), więc data rozwiązania umowy, tryb
   rozwiązania, notatki i lista czynności offboardingowych zostawały na dysku.
   SKUTEK DLA UŻYTKOWNIKA: na współdzielonej stacji następna osoba (choćby
   serwisant IT bez dostępu do e-teczki) mogła odczytać te dane z konsoli
   przeglądarki, mimo że sam moduł jest za uprawnieniem ETeczkaAccess.

   NAPRAWA: jedno miejsce z listą "wrażliwych" kluczy + jawne czyszczenie przy
   ŚWIADOMYM wylogowaniu. Celowo NIE czyścimy przy wygaśnięciu sesji (401 na
   /users/refresh) — kadrowa w trakcie wypełniania offboardingu straciłaby wtedy
   niezapisaną pracę, a po ponownym zalogowaniu na tej samej stacji ma ją odzyskać.
   Docelowo te dane powinny trafić do bazy (patrz raport A16-06 — brak API). */

// Klucze budowane per pracownik: `<prefiks><employeeId>`
export const SENSITIVE_HR_KEY_PREFIXES = [
    "eteczka_offboarding_",   // checklista, data zwolnienia, ostatni dzień pracy, notatki
    // [I-c etap 4, 2026-09-02] Ekran świadectwa NIE zapisuje już tego klucza — dane idą na serwer,
    // a wydany dokument jest plikiem w rejestrze wydań. Prefiks ZOSTAJE na liście czyszczenia:
    // na stacjach używanych przed tą zmianą szkice (powód rozwiązania, urlopy) nadal leżą na dysku.
    "eteczka_swiadectwo_",    // szkic świadectwa pracy — POZOSTAŁOŚĆ, do wyczyszczenia przy wylogowaniu
    "hr_emp_details_",        // dane zatrudnienia (etat, MPK, data zatrudnienia) — legacy
    "eteczka_profiles_",      // profil kadrowy — legacy
];

// Klucze o stałej nazwie (pozostałości po starszych wersjach; dziś nic ich nie zapisuje,
// ale na stacjach po aktualizacji mogą wciąż leżeć na dysku).
export const SENSITIVE_HR_KEYS = [
    "hr_dept_members",
    "hr_requests",
    "hr_work_schedules",
];

/**
 * Usuwa z localStorage dane kadrowe zapisane po stronie przeglądarki.
 * @param {Storage} [storage] magazyn do wyczyszczenia (domyślnie window.localStorage)
 * @returns {number} liczba usuniętych kluczy (na potrzeby testów/diagnostyki)
 */
export const clearSensitiveHrStorage = (storage) => {
    const store = storage || (typeof window !== "undefined" ? window.localStorage : null);
    if (!store) return 0;

    let removed = 0;
    try {
        const doomed = [];
        for (let i = 0; i < store.length; i += 1) {
            const key = store.key(i);
            if (!key) continue;
            if (SENSITIVE_HR_KEYS.includes(key) || SENSITIVE_HR_KEY_PREFIXES.some((p) => key.startsWith(p))) {
                doomed.push(key);
            }
        }
        doomed.forEach((key) => {
            store.removeItem(key);
            removed += 1;
        });
    } catch {
        /* prywatny tryb przeglądarki / zablokowany storage — nie ma czego czyścić */
    }
    return removed;
};

export default clearSensitiveHrStorage;
